import { ESdChangeReason, IKuikaStyle } from "@kuika/kuika-cl-model";
import { getSdInstance } from "../../../../../shared/utility/designer-context";
import {
  applyDesignerPropertyChange,
  setDesignerPropertyValue
} from "../../../../../shared/utility/designer-property-actions";
import { stylingPanelModeStore } from "../../../right-panel/styling-panel/styling-panel-mode-store";

/**
 * Every write the selection bar makes. They go through the same designer actions the right panel uses,
 * so each lands as one undo step and one collab op.
 */

/**
 * The component's styleObj as the designer holds it NOW — not as a render captured it. A debounced
 * style write reads this when it fires, so an edit that landed inside the debounce window (Bold, a style
 * tag, an undo) is patched rather than overwritten.
 */
function readLiveStyleObj(kuikaId: string): IKuikaStyle | undefined {
  return getSdInstance().screenProvider.getScreenDesignDictionary()[parseInt(kuikaId, 10)]?.styleObj;
}

/** A plain property value (text, option, number, boolean) — `PropertyFormItem.writeValue`'s path. */
export function writeQuickPropertyValue(kuikaId: string, propertyName: string, value: unknown): void {
  setDesignerPropertyValue(getSdInstance(), { kuikaId, propertyName, value });
}

/**
 * A styleObj built by `buildQuickStyleObj` / the style-tag helpers. Committed with
 * `ChangeStyleValueExternal`, so an open styling panel re-reads the component instead of letting its
 * own pending submit write the old values back.
 */
function writeQuickStyleObj(kuikaId: string, styleObj: IKuikaStyle): void {
  applyDesignerPropertyChange(
    getSdInstance(),
    { propertyName: "styleObj", value: styleObj, kuikaId },
    ESdChangeReason.ChangeStyleValueExternal
  );
}

/**
 * The one way the bar patches a styleObj: the styling panel's pending (debounced) edit is committed
 * first, then the live styleObj — now carrying it — is read and `build` patches it. Without the flush a
 * panel edit made just before a bar click was lost: the bar's write reloads the panel's form, which
 * drops the edit the panel had not submitted yet.
 */
export function commitQuickStyle(kuikaId: string, build: (live: IKuikaStyle | undefined) => IKuikaStyle): void {
  stylingPanelModeStore.flushPendingEdit();
  writeQuickStyleObj(kuikaId, build(readLiveStyleObj(kuikaId)));
}
